import { ViewMapDataRecordAccumulator, isMapDataDifferent, mapFunction, getEChartsActions } from '../functions'
import { call, CallEffect } from 'redux-saga/effects'
import { delay } from 'redux-saga/effects'

export const getHighlights = (apiDataRecords: MapDataItem[], echartsRef: any, oldValues: ViewMapDataRecord[], gradientDataLookup: { [K: string]: string }, mapDataSource: string): [CallEffect[], CallEffect, CallEffect[]] => {
    const instance = echartsRef.getEchartsInstance()
    const boundDispatchAction = instance.dispatchAction.bind(instance)
    const oldValuesDictionary = oldValues.reduce<ViewMapDataRecordAccumulator>(mapFunction, {})
    const diffedValues = apiDataRecords.filter(record => isMapDataDifferent(record, mapDataSource, oldValues, oldValuesDictionary)).map((record: MapDataItem) => record.name)
    const highlightCalls = diffedValues.map(item => getEChartsActions(boundDispatchAction, gradientDataLookup[item], 'highlight'))
    const downplayCalls = diffedValues.map(item => getEChartsActions(boundDispatchAction, gradientDataLookup[item], 'downplay'))
    return [highlightCalls, call(delay, 500), downplayCalls]
}
